/**
 * Bytes em unidade legível, base 1024 — a mesma que a fatura de armazenamento
 * do Azure usa. Base 1000 faria a tela discordar do custo.
 */
export function formatarBytes(bytes: number): string {
  if (!bytes) return "—";
  const unidades = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    unidades.length - 1,
  );
  const valor = bytes / 1024 ** i;
  return `${valor.toLocaleString("pt-BR", { maximumFractionDigits: valor < 10 ? 1 : 0 })} ${unidades[i]}`;
}
